import { z } from "zod"
import { requiredMessage } from "@/models/common"

const NAME_MINIMUM_LENGTH = 3
const SEARCH_TEXT_MAXIMUM_LENGTH = 100
const nameTooShortMessage = "episodeOfCare.betterDoc.preferredCareProvider.nameTooShort"
const characterLimitMessage = "common.fieldErrorList.characterLimit"

const optionalSearchText = z.string().trim().max(SEARCH_TEXT_MAXIMUM_LENGTH, characterLimitMessage).optional()

export const betterDocPreferredCareProviderSearchSchema = z.object({
  name: z
    .string({ error: requiredMessage })
    .trim()
    .min(1, requiredMessage)
    .min(NAME_MINIMUM_LENGTH, nameTooShortMessage)
    .max(SEARCH_TEXT_MAXIMUM_LENGTH, characterLimitMessage),
  city: optionalSearchText,
  street: optionalSearchText,
})

export type BetterDocPreferredCareProviderSearchFormSchema = z.infer<typeof betterDocPreferredCareProviderSearchSchema>
